import { Message } from "@au-schein-de/au-ui-library";
import { useTranslation } from "react-i18next";
import { useCart } from "./cart.context";

export function CartCapacityLimit() {
	const { t } = useTranslation("cart");
	const { remainingItemsLimit, remainingCapacity, maxTotalCartQuantity } =
		useCart();

	if (remainingCapacity !== 0 || remainingItemsLimit === 0) return null;

	return (
		<div className="px-3 md:px-6 pt-4">
			<Message
				variant="info"
				title={t("limit.monthlyLimitReached", {
					limit: maxTotalCartQuantity,
				})}
			>
				{t("limit.reduceToAdd")}
			</Message>
		</div>
	);
}
